export default __webpack_public_path__ + "static/media/tete57.f5b3596e.png";